module.exports = __webpack_public_path__ + "r-v3/img/draw_on.85068fee.svg";